import { PropsWithChildren } from "react";
import { useEditor, useNode, UserComponent, Element } from "@craftjs/core";
import { css } from "@emotion/react";

import { StyleSettings } from "../../../editor";
import { ImageSettings } from "./ImageSettings";
import {
  IBuilderBlockProps,
  BuilderBlock,
} from "../../shared/BuilderBock/BuilderBlock";
import { defaultCssStyles, defaultStyleProps } from "../../shared";

export const ImageContainer = ({ children }: any) => {
  const {
    connectors: { connect },
  } = useNode();
  return <div ref={connect as any}>{children}</div>;
};

export interface IImageProps extends IBuilderBlockProps {
  imageUrl: string;
  imageFit?: "cover" | "contain";
  imagePosition?:
    | "center top"
    | "center center"
    | "center bottom"
    | "left center"
    | "right center"
    | "left top"
    | "right top"
    | "left bottom"
    | "right bottom";
  altText?: string;
}

export const ImageComponent = ({ children }: any) => {
  const {
    connectors: { connect },
  } = useNode();
};

export const Image: UserComponent<Partial<PropsWithChildren<IImageProps>>> = ({
  imageUrl,
  imageFit = "cover",
  imagePosition = "center center",
  children,
  ...rest
}) => {
  const {
    connectors: { connect, drag },
    setProp,
  } = useNode();

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <BuilderBlock
      {...rest}
      position={imageFit == "cover" ? "absolute" : undefined}
      left={imageFit == "cover" ? "0" : undefined}
      top={imageFit == "cover" ? "0" : undefined}
      zIndex={imageFit == "cover" ? 0 : undefined}
    >
      <img
        src={
          imageUrl ??
          "https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d"
        }
        css={css`
          opacity: 1;
          transition: opacity 0.2s ease-in-out 0s;
          object-fit: ${imageFit};
          object-position: ${imagePosition};
          position: absolute;
          height: 100%;
          width: 100%;
          left: 0px;
          top: 0px;
        `}
      />

      {/* <Element is={BuilderBlock as any} id="image_container" canvas></Element> */}
    </BuilderBlock>
  );
};

Image.craft = {
  displayName: "Image",
  props: {},

  related: {
    toolbar: ImageSettings,
    styles: StyleSettings,
  },
};

Image.defaultProps = {
  ...defaultStyleProps,
  overflow: "hidden",
  minWidth: "20px",
  minHeight: "20px",
  width: "100%",
  height: "100%",
};
